"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.freeBlobResource = freeBlobResource;
exports.getDefaultHotSpot = getDefaultHotSpot;
exports.isHotSpotDrillDown = isHotSpotDrillDown;
exports.buildContentsIndex = buildContentsIndex;
exports.buildVideosIndex = buildVideosIndex;
exports.buildTopicsList = buildTopicsList;
exports.processLoadedContent = processLoadedContent;
exports.processLoadedSearchContent = processLoadedSearchContent;
exports.buildIndex = buildIndex;
exports.getContentPublication = getContentPublication;
exports.filterTopicsAndFolders = filterTopicsAndFolders;
exports.getCollapsedSearchResults = getCollapsedSearchResults;
exports.isUpdateAvailable = isUpdateAvailable;

var _index = require("../index");

var _immutable = _interopRequireWildcard(require("immutable"));

var _vehicle = require("./vehicle");

var _data = require("./data");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Release blob resource by URL
 *
 * @param {string} url
 */


function freeBlobResource(url) {
  URL.revokeObjectURL(url);
}
/**
 * Selects the best suitable hot spot and returns number
 *
 * @param {Array} hotspots
 * @returns {Number}
 */


function getDefaultHotSpot(hotspots) {
  // select the hot spot that contains more than one target
  var bestIndex = hotspots.findIndex(function (hotspot) {
    return hotspot.targets.length > 1;
  }); // default to "0" if index not found (-1)

  return Math.max(0, bestIndex);
}
/**
 * Detects whether hot-spot contains drill down target
 *
 * @param {Array} targets
 * @param {Array} imageMaps
 * @returns {boolean}
 */


function isHotSpotDrillDown(targets, imageMaps) {
  if (targets.length !== 1) {
    return false;
  }

  return imageMaps.map(function (x) {
    return x.resourceKey;
  }).includes(targets[0]);
}
/**
 * Contents index used for quick content items lookup via resourceKey
 *
 * @param {Immutable.List} publications
 * @param {Immutable.List} folders
 * @param {Immutable.List} topics
 * @returns {Immutable.Map}
 */


function buildContentsIndex(publications, folders, topics) {
  function keyIn() {
    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }

    var keySet = _immutable.default.Set(keys);

    return function (v, k) {
      return keySet.has(k);
    };
  }

  var _getConfig = (0, _index.getConfig)(),
      BROWSE_FOLDERS_KEYS = _getConfig.BROWSE_FOLDERS_KEYS,
      BROWSE_ROOT_KEY = _getConfig.BROWSE_ROOT_KEY,
      PUBLICATIONS_ORDER = _getConfig.PUBLICATIONS_ORDER;

  var keySet = keyIn.apply(void 0, _toConsumableArray(BROWSE_FOLDERS_KEYS));
  var keySetPubs = keyIn.apply(void 0, [].concat(_toConsumableArray(BROWSE_FOLDERS_KEYS), ['publicationSubType']));

  var index = _immutable.default.Map(folders.map(function (folder) {
    return [folder.get('resourceKey'), folder.filter(keySet)];
  }));

  if (publications.size > 1) {
    // Subaru publications order can't be set on CD/PubHub
    // so we temporary (permanently?) set the order on client
    publications = (0, _data.sortItemsByFieldInOrder)(publications, 'publicationSubType', PUBLICATIONS_ORDER);
    index = index.merge( // adding publications into indexed list
    publications.map(function (publication) {
      return [publication.get('resourceKey'), publication.filter(keySetPubs)];
    }), // adding ROOT element with publications to the list
    (0, _immutable.fromJS)(_defineProperty({}, BROWSE_ROOT_KEY, {
      "contents": publications.map(function (publication) {
        return publication.filter(keyIn('id', 'type'));
      }),
      "type": BROWSE_ROOT_KEY
    }))); // if only 1 publications -> make it root
  } else {
    index = index.merge((0, _immutable.fromJS)(_defineProperty({}, BROWSE_ROOT_KEY, publications.get(0).filter(keySetPubs).set('resourceKey', ''))));
  } // filling all contents together into flatten tree


  return index.map(function (folder) {
    if (!folder.get('contents')) return folder; // merge all child items searched by item ID (also dropping redundant "contents" property)

    var contents = folder.get('contents').map(function (item) {
      var data = {
        "publication": publications,
        "folder": folders,
        "topic": topics
      }[item.get("type")].find(function (subitem) {
        return subitem.get('id') === item.get('id');
      });

      if (data) {
        return item.merge(data.delete("contents"));
      } // for incomplete bundles we may endup with IDs in contents that are pointing to content that doesn't exists
      // we end up with null value being returned and those should be filtered


      return null;
    }).filter(function (x) {
      return x;
    });
    return folder.set("contents", _immutable.default.OrderedMap(contents.map(function (item) {
      if (item.get('type') === 'publication') {
        item = item.set('alias', "".concat(BROWSE_ROOT_KEY, "/").concat((0, _vehicle.getPathAlias)(item.get('title'))));
      } else if (item.get('type') === 'folder') {
        item = item.set('alias', "".concat((0, _vehicle.getPathAlias)(folder.get('title')), "/").concat((0, _vehicle.getPathAlias)(item.get('title'))));
      }

      return [item.get('resourceKey'), item.filter(keySet)];
    })));
  });
}
/**
 * Builds the map of resourceKey => video
 *
 * @param {Array} videos
 * @returns {Object}
 */


function buildVideosIndex() {
  var videos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return videos.reduce(function (acc, cur) {
    // Add the related topic id to the index as well. This is a backwards compatability fix and should
    // be removed when incompatable apps are fixed.
    if (cur.relatedTopics && cur.relatedTopics.length > 0) {
      var topicResourceKey = cur.relatedTopics[0]; // note that there is only one topic per video

      acc[topicResourceKey] = cur;
    }

    if ('resourceKey' in cur) {
      acc[cur['resourceKey']] = cur;
    }

    return acc;
  }, {});
}
/**
 * Builds the list of topics enriched with video objects attached to the topic
 *
 * Right now it is considered that each topic will have only single video
 *
 * @param {Array} topics
 * @param {Object} videosIndex
 * @returns {Array} topics with attached video
 */


function buildTopicsList(topics, videosIndex) {
  return topics.map(function (topic) {
    var result = _objectSpread({}, topic); // shallow copy the object


    if (result.relatedContents) {
      result.relatedContents.forEach(function (resourceKey) {
        if (resourceKey in videosIndex) {
          // TODO This is still assuming there is only one video per topic
          result.video = videosIndex[resourceKey];
        }
      });
    } else if (topic.resourceKey in videosIndex) {
      // link video object with topic. This is a backwards compatiability fix and should be removed
      // When clients don't relie on topic.resourceKey for building the video index
      result.video = videosIndex[topic.resourceKey];
    }

    if (result.video) {
      if (result.video.markers && !result.video.markers.find(function (x) {
        return x.timestamp === 0;
      })) {
        // add automatic zero time marker if markers are available and there are no 0:00 timestamp already from PubHub
        result.video.markers = [{
          timestamp: 0,
          title: topic.title
        }].concat(_toConsumableArray(result.video.markers));
      }
    }

    return result;
  });
}
/**
 * Converts loaded content into state object
 *
 * @param {Object} state
 * @param {Object} payload
 * @returns {Object} state object
 */


function processLoadedContent(state, payload) {
  var _getConfig2 = (0, _index.getConfig)(),
      IMAGE_MAPS_ORDER = _getConfig2.IMAGE_MAPS_ORDER;

  var data = _objectSpread({
    topics: [],
    folders: [],
    publications: [],
    videos: [],
    heroShots: []
  }, payload); // init fields


  var videosIndex = buildVideosIndex(data.videos);

  var newState = _objectSpread({}, state, {
    topics: (0, _immutable.fromJS)(buildTopicsList(data.topics, videosIndex)),
    searchTopics: (0, _immutable.fromJS)([]),
    searchFolders: (0, _immutable.fromJS)([]),
    searchQuery: '',
    videosIndex: videosIndex,
    folders: (0, _immutable.fromJS)(data.folders),
    foldersIndex: null,
    contentIndex: null,
    publications: (0, _immutable.fromJS)(data.publications),
    imageMaps: (0, _data.sortItemsByFieldInOrder)(data.imageMaps, 'title', IMAGE_MAPS_ORDER),
    fetching: false
  });

  if (payload.publications && payload.publications.length) {
    newState.contentIndex = buildIndex(data.publications, data.folders, data.topics);
    newState.foldersIndex = buildContentsIndex(newState.publications, newState.folders, newState.topics);
  }

  return newState;
}
/**
 * Processes search results
 *
 * @param {Object} state
 * @param {Object} payload
 * @returns {{searchTopics: any, fetching: boolean}}
 */


function processLoadedSearchContent(state, payload) {
  var data = _objectSpread({
    topics: [],
    folders: [],
    publications: [],
    videos: []
  }, payload); // init fields


  return _objectSpread({}, state, {
    searchTopics: (0, _immutable.fromJS)(buildTopicsList(data.topics, state.videosIndex || {})),
    searchFolders: (0, _immutable.fromJS)(data.folders),
    fetching: false
  });
}
/**
 * Contents index used for quick content items lookup via resourceKey
 *
 * @param {Array} publications
 * @param {Array} folders
 * @param {Array} topics
 * @returns {Object}
 */


function buildIndex(publications, folders, topics) {
  var _getConfig3 = (0, _index.getConfig)(),
      BROWSE_ROOT_KEY = _getConfig3.BROWSE_ROOT_KEY;

  var index = {}; // Run through folders and topics and add them to index by ID

  publications.forEach(function (item) {
    return index[item.id] = _objectSpread({}, item, {
      type: 'publication'
    });
  });
  folders.forEach(function (item) {
    return index[item.id] = item;
  });
  topics.forEach(function (item) {
    return index[item.id] = item;
  }); // Assign a root

  if (publications.length === 1) {
    // If there is only one publication - make it root
    index[BROWSE_ROOT_KEY] = publications[0];
  } else {
    index[BROWSE_ROOT_KEY] = {
      id: BROWSE_ROOT_KEY,
      type: BROWSE_ROOT_KEY,
      contents: publications.map(function (pub) {
        return {
          id: pub.id,
          type: 'publication'
        };
      })
    };
  } // Build references to parents so that we could quickly lookup the publication for each topic/folder
  // This is needed for new Google Analytics functionality
  // Unfortunately there is no easy way to extract the parent item except running through all of them


  Object.keys(index).forEach(function (key) {
    if (!index[key].contents) {
      return; // skip processing items if it doesn't has child items
    } // Each item should be updated to contain ID of its parent


    index[key].contents.forEach(function (item) {
      if (!index[item.id]) {
        // references to content that isn't there yet
        return; // skip incomplete publications (draft preview, etc)
      }

      index[item.id].parent = index[key].id; // each child item will get a reference to parent ID
    });
  });
  return index;
}
/**
 * Extracts the publication object from parents chain
 *
 * @param {String} itemId
 * @param {Object} contentIndex
 * @return {Object}
 */


function getContentPublication(itemId, contentIndex) {
  var item = contentIndex[itemId];

  if (item.type === 'publication') {
    return item; // return publication when reached
  }

  return getContentPublication(item.parent, contentIndex); // Recursively runs through parents chain
}
/**
 * Filters topics and folders which belong to given publication
 *
 * @param {Array} data
 * @param {Object} publication
 * @returns {{topics: Array, folders: Array}}
 */


function filterTopicsAndFolders(data, publication) {
  var filteredData = {};
  var rootFoldersIDs = publication.contents.filter(function (c) {
    return c.type === 'folder';
  }).map(function (i) {
    return i.id;
  });
  var rootTopicsIDs = publication.contents.filter(function (c) {
    return c.type === 'topic';
  }).map(function (i) {
    return i.id;
  }); // init filtered folders and topics with root ones

  var filteredFolders = data.folders.filter(function (folder) {
    return rootFoldersIDs.includes(folder.id);
  });
  var filteredTopics = data.topics.filter(function (topic) {
    return rootTopicsIDs.includes(topic.id);
  });
  var childFoldersIDs = []; // helper function which adds folder contents to filteredFolders and filteredTopics arrays

  var addFolderContents = function addFolderContents(folderId) {
    var folder = data.folders.find(function (f) {
      return f.id === folderId;
    });
    folder.contents.forEach(function (content) {
      if (content.type === 'topic') {
        filteredTopics.push(data.topics.find(function (t) {
          return t.id === content.id;
        }));
      } // if folder contains another folder move it to child folders array


      if (content.type === 'folder') {
        filteredFolders.push(data.folders.find(function (f) {
          return f.id === content.id;
        }));
        childFoldersIDs.push(content.id);
      }
    });
  }; // start from root folders and add their contents iteratively


  rootFoldersIDs.forEach(function (rootFolderID) {
    addFolderContents(rootFolderID); // iterate over child folders

    while (childFoldersIDs.length) {
      var childFolderID = childFoldersIDs.shift();
      addFolderContents(childFolderID);
    }
  });
  filteredData.topics = filteredTopics;
  filteredData.folders = filteredFolders;
  return filteredData;
}
/**
 * Show list of found topics including collapsed content
 *
 * TODO: move me out of core, as this will not be used by any other client
 *
 * @deprecated This method is used only by FR projects and should be avoided in all other client apps
 * @param {Immutable.List} searchTopics
 * @param {Immutable.List} searchFolders
 * @param {Immutable.List} folders
 * @param {Immutable.Map} foldersIndex
 * @returns {Immutable.List}
 */


function getCollapsedSearchResults(searchTopics, searchFolders, folders, foldersIndex) {
  if (searchTopics) {
    searchTopics = searchTopics.map(function (topic) {
      var parentFolder = foldersIndex.find(function (folder) {
        return folder.get("contents").keySeq().contains(topic.get("resourceKey"));
      });
      if (parentFolder && parentFolder.get('bodyHtml')) return folders.find(function (folder) {
        return folder.get('resourceKey') === parentFolder.get('resourceKey');
      });
      return topic;
    }); // concat with results from folders containing bodyHtml

    if (searchFolders) searchTopics = searchTopics.concat(searchFolders.filter(function (folder) {
      return !!folder.get('bodyHtml');
    })); // remove duplicates

    searchTopics = searchTopics.reduce(function (uniques, item) {
      return !uniques.includes(item) ? uniques.push(item) : uniques;
    }, (0, _immutable.List)());
  }

  return searchTopics;
}
/**
 * Detects whether the there is an update against content available offline
 *
 * Comparison is based only on publication versions
 *
 * The rest of content is ignored as we don't store anything else than publications for offline usage
 *
 * @param {Array} pubsBefore
 * @param {Array} pubsAfter
 * @returns {Boolean}
 */


function isUpdateAvailable(pubsBefore, pubsAfter) {
  if (!pubsAfter) {
    // no data, no updates available
    return false;
  }

  if (pubsBefore.length !== pubsAfter.length) {
    // different number of publications available, probably update arrived
    return true;
  }

  var _loop = function _loop(i) {
    if (!pubsAfter[i].bundle) {
      // ignore items that don't have downloadable bundles
      return "continue";
    }

    var before = pubsBefore.find(function (x) {
      return x.resourceKey === pubsAfter[i].resourceKey;
    });

    if (!before) {
      // new publication arrived, obviously an update
      return {
        v: true
      };
    }

    if (before.version < pubsAfter[i].version) {
      // new version of the same publication arrived
      return {
        v: true
      };
    }
  };

  for (var i = 0; i < pubsAfter.length; ++i) {
    var _ret = _loop(i);

    switch (_ret) {
      case "continue":
        continue;

      default:
        if (_typeof(_ret) === "object") return _ret.v;
    }
  } // seams to be all versions are equal, so no updates available


  return false;
}